module.exports = __webpack_public_path__ + "static/media/right-arrowe.5a72887e.svg";